<template>
  <div class="external-component2">
  </div>
</template>

<script>
import {store} from './wuhanData'
const d3 = Object.assign({}, require('d3-request'), require('d3-selection'), require('d3-scale'), require('d3-array'), require('d3-axis'))

export default {
  props: ['attributes'],
  data () {
    return {
      ready: false
    }
  },
  methods: {
    initCode () {
      const rawData = [...this.rawData]

      const confirmedOther = rawData.filter(d => d['case-status'] === 'Confirmed')
          .filter(d => d.area === 'Other')
          .sort((a, b) => b.count - a.count)

      var width = this.$el.clientWidth
      var margin = {top: 0, right: 10, bottom: 0, left: 70}
      var tableWidth = width - margin.left - margin.right
      var maxX = confirmedOther[0].count
      var barHeight = 25
      var unitLength = barHeight / 0.7
      var tableHeight = confirmedOther.length * unitLength

      d3.select(this.$el).append('svg')
            .attr('id', 'barchart')
            .attr('height', tableHeight + margin.top)
            .attr('width', '100%')

      const svg2 = d3.select('#barchart')
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      var y = d3.scaleBand()
            .range([0, tableHeight])
            .padding(0)

      var x = d3.scaleLinear()
                    .range([0, tableWidth])

      confirmedOther.forEach(function (d) {
        d.count = +d.count
      })

      x.domain([0, maxX])
      y.domain(confirmedOther.map(function (d) {
        return d['province/country']
      }))

      var bars = svg2.selectAll('.bar')
              .data(confirmedOther)
              .enter()
              .append('g')

      bars.append('rect')
              .attr('class', 'bar')
              .attr('width', function (d) { return x(d.count) })
              .attr('y', function (d) { return y(d['province/country']) })
              .attr('height', barHeight)

      bars.append('text')
              .attr('class', 'tableLabel')
              .attr('y', function (d) {
                return y(d['province/country']) + y.bandwidth() / 2
              })
              .attr('x', function (d) {
                return x(d.count) > 16 ? x(0) + 2 : x(d.count) + 2
              })
              .style('fill', function (d) {
                return x(d.count) > 16 ? 'white' : 'black'
              })
              .text(function (d) {
                return d.count
              })

      // add the y Axis
      svg2.append('g')
              .call(d3.axisLeft(y))
              .call(g => g.select('.domain').remove())
              .call(g => g.selectAll('line').remove())
              .attr('transform', 'translate(0 , -' + (barHeight / 2 - 7) + ')')

      d3.selectAll('.tick text').attr('class', 'tableText')

      this.ready = true
    }
  },
  computed: {
    rawData () {
      return store.rawData
    }
  },
  watch: {
    rawData () {
      if (this.rawData && !this.ready) {
        this.initCode()
      }
    }
  },
  mounted () {
    if (this.rawData) {
      this.initCode()
    }
  }
}
</script>
<style lang="scss">
.external-component2 {
  text {
    font-family: $font-CuratorRegular;
    font-size: 20px;
    @include breakpoint($d_medium) {
      font-size: 12px;
    }
    tspan {
      font-family: $font-CuratorBold;
    }
  }

  .bar {
    fill: #D4883D;
  }

  .tableText {
    font-size: 16px;
  }

  .tableLabel {
    font-size: 16px;
  }

  .tableTitle {
    font-size: 24px;
    font-family: $font-CuratorBold;
  }
}
</style>
